/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskPoliciesListMcpPlatformToolsets } from "../funcs/riskPoliciesListMcpPlatformToolsets.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListMCPPlatformToolsetsResult } from "../models/components/listmcpplatformtoolsetsresult.js";
import {
  ListMCPPlatformToolsetsRequest,
  ListMCPPlatformToolsetsSecurity,
} from "../models/operations/listmcpplatformtoolsets.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskListMcpPlatformToolsetsQueryData =
  ListMCPPlatformToolsetsResult;

export function prefetchRiskListMcpPlatformToolsets(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListMCPPlatformToolsetsRequest | undefined,
  security?: ListMCPPlatformToolsetsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskListMcpPlatformToolsetsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskListMcpPlatformToolsetsQuery(
  client$: GramCore,
  request?: ListMCPPlatformToolsetsRequest | undefined,
  security?: ListMCPPlatformToolsetsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RiskListMcpPlatformToolsetsQueryData>;
} {
  return {
    queryKey: queryKeyRiskListMcpPlatformToolsets({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function riskListMcpPlatformToolsetsQueryFn(
      ctx,
    ): Promise<RiskListMcpPlatformToolsetsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskPoliciesListMcpPlatformToolsets(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskListMcpPlatformToolsets(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "policies", "listMcpPlatformToolsets", parameters];
}
